import ArrowRightRoundedIcon from "@mui/icons-material/ArrowRightRounded";

export default function ExpandMediumIcon() {
  return <ArrowRightRoundedIcon fontSize="medium" />;
}
